import { UqButton } from '@uniqore/wrapper'
import styled from 'styled-components'

export const StyledButton = styled(UqButton)({
  textTransform: 'none',
  padding: '16px 24px'
})
